import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from './maintenance.service';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  hil_maintenance_description: String;
  hil_maintenance_return_time: String;
  isLoading: Boolean;

  constructor(private maintenanceService: MaintenanceService,
              private spinner: NgxSpinnerService) {

  }
  ngOnInit() {
    this.isLoading = true;
    this.spinner.show();
    this.maintenanceService.fetchSSMValues().subscribe(res => {
      let ssmValues = res;
      this.hil_maintenance_description = ssmValues['hil_maintenance_description'];
      this.hil_maintenance_return_time = ssmValues['hil_maintenance_return_time'];
      this.spinner.hide();
      this.isLoading = false;
    })
  }

}
